import { t } from "@auto/services";
export const getField = (row, camelName, snakeName) => {
  return row?.[camelName] ?? row?.[snakeName] ?? "";
};

export const getNumericField = (row, camelName, snakeName) => {
  const value = getField(row, camelName, snakeName);

  if (value === null || value === undefined || value === "") {
    return "";
  }

  return value;
};

export const normalizeTags = (tags) => {
  if (!tags || typeof tags !== "object" || Array.isArray(tags)) {
    return {};
  }

  return tags;
};

export const labelOf = (row) => {
  if (!row) {
    return "";
  }

  const code = String(row.code || "").trim();
  const name = String(row.name || "").trim();

  if (code && name) {
    return `${code} - ${name}`;
  }

  return name || code || t("common.unnamed");
};

export const votingCenterLabel = (row) => {
  if (!row) {
    return "";
  }

  const base = labelOf(row);
  const address = String(row.address || "").trim();

  return address ? `${base}\n${address}` : base;
};

export const entityTitle = (entity) => {
  switch (entity) {
    case "department":
      return t("person.department");
    case "arrondissement":
      return t("geo.arrondissement");
    case "constituency":
      return t("geo.constituency");
    case "commune":
      return t("person.commune");
    case "section":
      return t("person.section");
    case "voting-center":
      return t("voter.votingCenter");
    default:
      return t("geo.item");
  }
};

export const childEntityFor = (type) => {
  switch (type) {
    case "department":
      return "arrondissement";
    case "arrondissement":
      return "commune";
    case "constituency":
      return "commune";
    case "commune":
      return "section";
    case "section":
      return "voting-center";
    default:
      return "";
  }
};

export const createChildPayload = (entity, parent, parentType, values) => {
  switch (entity) {
    case "department":
      return values;

    case "constituency":
      return values;

    case "arrondissement":
      return {
        ...values,
        departmentGid: parent?.gid,
      };

    case "commune":
      return {
        ...values,
        arrondissementGid:
          parentType === "arrondissement"
            ? parent?.gid
            : values.arrondissementGid,
        constituencyGid:
          parentType === "constituency"
            ? parent?.gid
            : values.constituencyGid,
      };

    case "section":
      return {
        ...values,
        communeGid: parent?.gid,
      };

    case "voting-center":
      return {
        ...values,
        sectionGid: parent?.gid,
      };

    default:
      return values;
  }
};

export const mergeEntity = (item, patch) => {
  if (!item) {
    return item;
  }

  if (!patch?.gid || item.gid !== patch.gid) {
    return item;
  }

  return {
    ...item,
    ...patch,
  };
};
